import React from 'react';
import PropTypes from 'prop-types';
import generalStyles from './style/general.css';

export default function CardFooter({ children }) {
  return (
    <footer className={generalStyles.wrap}>
      <div className={generalStyles.footer}>
        <div className={generalStyles.border} />
        {children}
      </div>
    </footer>
  );
}

CardFooter.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardFooter/index.js